import { useSetAtom } from 'jotai';
import { memo, useEffect } from 'react';
import { useSearchRoute } from '../hook/useSearchRoute';
import { searchHelperParamsAtom } from './searchHelperParams.atom';
import { searchHelperFilterAtom } from './searchHelperFilter.atom';
import { useAgeFilters } from '../queries/useAgeFilters';

const InitializeStore: React.FC<{ children: React.ReactNode }> = props => {
  const route = useSearchRoute<'SearchHelper'>();

  const setParams = useSetAtom(searchHelperParamsAtom);
  const setFilter = useSetAtom(searchHelperFilterAtom);

  const { data: ageFilterData } = useAgeFilters();

  // 1. 딥링크 params 저장 (query, show_keyboard 제외)
  // query: SearchHelper.page.tsx에서 직접 처리 (딥링크 자동검색 / 사용자 입력)
  // show_keyboard: SearchHelper.page.tsx에서 ref로 1회 소비 후 폐기
  useEffect(() => {
    const { query: _query, show_keyboard: _showKeyboard, ...restParams } = route.params;
    setParams(prev => ({ ...prev, ...restParams }));
  }, [route.params, setParams]);

  // 2. 연령대 필터 초기화
  useEffect(() => {
    if (!ageFilterData) return;

    setFilter({
      selectedAge: 0, // 전체
      ageFilters: ageFilterData.ages,
    });
  }, [ageFilterData, setFilter]);

  return <>{props.children}</>;
};

export const ScreenStateProvider = memo(
  ({ children }: { children: React.ReactNode }) => {
    return <InitializeStore>{children}</InitializeStore>;
  },
);
